import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { ExpandableList } from '@bibliocommons/expandable';
import { UserCircle } from '@bibliocommons/base-icons';
import { MOVIE_DB_IMG_BASE_PATH } from 'app/constants/MoviesConstants';

import './MovieContributors.scss';

function renderImage(contributor) {
  if (contributor.get('profilePath')) {
    const url = `${MOVIE_DB_IMG_BASE_PATH}/${contributor.get('profilePath')}`;
    return <img className="contributor-image" alt={contributor.get('name')} src={url} loading="lazy" />;
  }

  return <UserCircle className="contributor-image" />;
}

function renderCast(contributor) {
  return (
    <div className="contributor-wrapper">
      {renderImage(contributor)}
      <div className="contributor-details">
        <div className="contributor-name">{contributor.get('name')}</div>
        <div className="character">{contributor.get('character')}</div>
      </div>
    </div>
  );
}

export default class MovieContributors extends React.PureComponent {
  renderContributors() {
    return (
      <ExpandableList
        className="contributor-list"
        itemClassName="contributor-item"
        list={this.props.cast}
        getItemKey={contributor => contributor.get('name')}
        renderItem={contributor => renderCast(contributor)}
        expandLinkHref="#show-more-contributors"
        textKey="contributors"
        collapseCount={4}
      />
    );
  }

  render() {
    return <div className="cp-movie-contributors">{this.renderContributors()}</div>;
  }
}

MovieContributors.propTypes = {
  cast: ImmutablePropTypes.list.isRequired
};
